import * as Interfaces from 'app/interfaces';

export function getAddressFromState(
  //addressState: Interfaces.Common.Organisation['address']
  addressState: any
): Interfaces.API.Address {
  if (addressState.fullDetails.apiFullAddress) {
    // If the address was selected from the Experian API, source the address from its response
    return {
      street: addressState.fullDetails.apiFullAddress.addressLine1,
      city: addressState.fullDetails.apiFullAddress.suburbOrPlaceOrLocality,
      state: addressState.fullDetails.apiFullAddress.stateOrTerritory,
      postcode: addressState.fullDetails.apiFullAddress.postCode,
      country: addressState.fullDetails.apiFullAddress.country,
      addressValidated: true
    };
  } else {
    // Otherwise, use the component provided address derived from manual form inputs
    return {
      street: addressState.fullDetails.fullAddress,
      city: addressState.fullDetails.suburb,
      state: addressState.fullDetails.state,
      postcode: addressState.fullDetails.postCode,
      country: 'AUSTRALIA',
      addressValidated: false
    };
  }
}
